import camelCase from 'lodash/camelCase';

export default function getQueryField(prefix, hasLocalNews) {
  return hasLocalNews
    ? camelCase(`increase ${prefix} NewsArticleHits`)
    : 'increaseNewsArticleHits';
}
